var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24998 8.62501H4.33331M9.74998 8.62501V10.25C9.74998 11.2716 9.74998 11.7818 9.49594 12.0993C9.25381 12.4026 8.87031 12.4161 8.12498 12.4167M9.75431 3.75001H9.7489M4.33331 12.4167H3.24998C2.2284 12.4167 1.71815 12.4167 1.40073 12.0993C1.08331 11.7818 1.08331 11.2716 1.08331 10.25L1.08331 9.16668C1.08331 8.14509 1.08331 7.63484 1.40073 7.31743C1.71815 7.00001 2.2284 7.00001 3.24998 7.00001H4.33331C5.3549 7.00001 5.86515 7.00001 6.18256 7.31743C6.49998 7.63484 6.49998 8.14509 6.49998 9.16668V10.25C6.49998 11.2716 6.49998 11.7818 6.18256 12.0993C5.86515 12.4167 5.3549 12.4167 4.33331 12.4167ZM9.74998 1.58334C8.5529 1.58334 7.58331 2.56322 7.58331 3.77168C7.58331 4.46284 7.85415 5.00018 8.39581 5.48009C8.77769 5.81864 9.24027 6.38089 9.5176 6.83589C9.65085 7.05472 9.83936 7.05472 9.98236 6.83589C10.2738 6.38955 10.7223 5.81864 11.1041 5.48064C11.6458 5.00018 11.9166 4.46284 11.9166 3.77168C11.9166 2.56376 10.9471 1.58334 9.74998 1.58334Z",
    stroke: "#673C8E",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.cf24f3ea8421ee08a501877696a3555d.svg";
export { ForwardRef as ReactComponent };